import { Directive } from '@angular/core';

@Directive({ standalone: true })
export abstract class FormFieldControl {
  /** The element ID for this control. */
  readonly id: string;

  /** Whether the control is required. */
  readonly required: boolean;

  /** Whether the control is disabled. */
  readonly disabled: boolean;

  /** Whether the control is in an error state. */
  readonly errorState?: boolean;
}
